 /*=========================================================================================
  File Name: gettes.js
  Description: Payment Getters
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/
import PriceCalculator from "../../../commons/priceCalculator";

export default {
    fullAddress : (state) => {
        return state.orderConfirmation.address + ', ' + state.orderConfirmation.postNumber + ' ' + state.orderConfirmation.city;
    },
    totalPrice : (state) => {
        let total = 0;
        state.orderConfirmation.orderDetails.forEach(item => {
            let finalPrice = PriceCalculator.getProductPrice(item.itemPrice, item.addedPrice, item.discount);
            total += ( item.quantity * Math.round(finalPrice) );
        });
        return total;
    },
    totalTax: (state) => {
        let total = 0;
        state.orderConfirmation.orderDetails.forEach(item => {
            let finalPrice = PriceCalculator.getProductPrice(item.itemPrice, item.addedPrice, item.discount);
            total += (item.quantity * item.tax * Math.round(finalPrice)) / 100.0;
        });
        return total.toFixed(2);
    }
}